import store from '@/store'
import { recordLogHistory, LOG_HISTORY_TYPE } from '@/api/profile'

export { LOG_HISTORY_TYPE }

export function recordBrowseHistory(type, dataId) {
  if (!store.getters.isLoggedIn || !dataId || !type) {
    return Promise.resolve(false)
  }
  return recordLogHistory({
    type,
    dataId: String(dataId)
  }).catch(() => false)
}
